/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
// import Image from 'next/image';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

import styles from '../contentPage.module.scss';
import Image from 'next/image';


import NextSeoWrapper from '@/components/NextSeoWrapper';
import PageContainer from '@/components/PageContainer';
import { getLanguageAlternates } from '@/utils/locale';
import { getCanonicalUrl } from '@/utils/navigation';

const path = '/masjid';
const MasjidPage = () => {
    const { t, lang } = useTranslation('masjid');
    const members = [
        { sr: 1, name: "Masood Ahmad", designation: "President", occupation: "Retired Army Officer" },
        { sr: 2, name: "Gazanfir Ali", designation: "Vice President", occupation: "Business" },
        { sr: 3, name: "Abdul Rauf Khan", designation: "General Secretary", occupation: "Retired Army Officer" },
        { sr: 4, name: "Muhammad Anwar", designation: "Joint secretary", occupation: "Business" },
        { sr: 5, name: "Muhammad Iqbal", designation: "Finance Secretary", occupation: "Private Job" },
        { sr: 6, name: "Aftab Ahmad", designation: "Member", occupation: "Retired Army Officer" },
        { sr: 7, name: "Muhammad Nadeem", designation: "Member", occupation: "Business" },
    ];

    return (
        <>
            <NextSeoWrapper
                title="masjid"
                url={getCanonicalUrl(lang, path)}
                languageAlternates={getLanguageAlternates(path)}
            />
            <PageContainer>
                <div className={styles.historyPage}>
                    <h1 style={{ textAlign: 'center' }}>{t('masjid:estab')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:parahgraph-1"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('masjid:objective')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:parahgraph-2"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('masjid:management')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:parahgraph-3"
                        />
                    </p>
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>Sr No</th>
                                    <th>Name</th>
                                    <th>Designation</th>
                                    <th>Occupation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {members.map((member) => (
                                    <tr key={member.sr}>
                                        <td>{member.sr}</td>
                                        <td>{member.name}</td>
                                        <td>{member.designation}</td>
                                        <td>{member.occupation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <h1 style={{ textAlign: 'center' }}>{t('masjid:projects')}</h1>
                    <h1>{t('masjid:projects-txt-1')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:projects-parahgraph-1"
                        />
                    </p>
                    <h1>{t('masjid:projects-txt-2')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:projects-parahgraph-2"
                        />
                    </p>
                    <h1>{t('masjid:projects-txt-3')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:projects-parahgraph-3"
                        />
                    </p>
                    <h1>{t('masjid:projects-txt-4')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:projects-parahgraph-4"
                        />
                    </p>
                    <h1>{t('masjid:projects-txt-5')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:projects-parahgraph-5"
                        />
                    </p>
                    <h1>{t('masjid:projects-txt-6')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:projects-parahgraph-6"
                        />
                    </p>
                    <h1>{t('masjid:projects-txt-7')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:projects-parahgraph-7"
                        />
                    </p>
                    <p style={{ fontWeight: 'bold' }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:projects-parahgraph-8"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('masjid:dev-work')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:parahgraph-4"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('masjid:daily-routine')}</h1>
                    <p className={styles.lineHeigh} style={{ color: "orange" }}>
                        <Trans
                            i18nKey="masjid:parahgraph-5"
                        />
                    </p>
                    <h1>{t('masjid:DR-txt-1')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:DR-parahgraph-1"
                        />
                    </p>
                    <h1>{t('masjid:DR-txt-2')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:DR-parahgraph-2"
                        />
                    </p>
                    <h1>{t('masjid:DR-txt-3')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:DR-parahgraph-3"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('masjid:funds')}</h1>
                    <h1>{t('masjid:funds-txt-1')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:funds-parahgraph-1"
                        />
                    </p>
                    <h1>{t('masjid:funds-txt-2')}</h1>
                    <div style={{ textAlign: 'center', padding: "10px" }}>
                        <Image src="/images/donate.png" width={799} height={960} layout="responsive" alt="Donate" />
                    </div>
                    <h1>{t('masjid:funds-txt-3')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="masjid:funds-parahgraph-3"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('masjid:contact')}</h1>
                    <p style={{ fontWeight: 'bold' }}>
                        <Trans
                            i18nKey="masjid:contact-parahgraph-1"
                        />
                    </p>
                    <p >
                        <Trans
                            i18nKey="masjid:contact-parahgraph-2"
                        />
                    </p>
                    <p >
                        <Trans
                            i18nKey="masjid:contact-parahgraph-3"
                        />
                    </p>
                    <p >
                        <Trans
                            i18nKey="masjid:contact-parahgraph-4"
                        />
                    </p>
                    <p >
                        <Trans
                            i18nKey="masjid:contact-parahgraph-5"
                        />
                    </p>
                    <p >
                        <Trans
                            i18nKey="masjid:contact-parahgraph-6"
                        />
                    </p>
                    <p >
                        <Trans
                            i18nKey="masjid:contact-parahgraph-7"
                        />
                    </p>
                </div>
            </PageContainer>
        </>
    );
};

export default MasjidPage;
